import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { toBucket } from './toBucket';

export const inputActions = [toBucket];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
